/**
 * HR Documents rows a surveyor is allowed to see.
 * Other roles do not use this filter.
 *
 * Forms: a saved record whose status is Sent to Office, To Be Corrected,
 * or Completed.
 * Uploads (credentials, tax): at least one uploaded file.
 */

const SURVEYOR_VISIBLE_FORM_STATUSES = new Set([
  "send_to_office",
  "sent_to_office",
  "filled",
  "to_be_corrected",
  "completed",
]);

export const SURVEYOR_EMPTY_DOCUMENTS_MESSAGE =
  "No submitted documents to review.";

function normalizeStatus(status) {
  return String(status ?? "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
}

function rowWorkflowStatus(row) {
  const fromDetail = row?.detail?.status;
  if (fromDetail != null && String(fromDetail).trim() !== "") {
    return normalizeStatus(fromDetail);
  }
  return normalizeStatus(row?.status);
}

export function isSurveyorVisibleSubmittedForm(row) {
  if (row?.detail == null) return false;
  return SURVEYOR_VISIBLE_FORM_STATUSES.has(rowWorkflowStatus(row));
}

export function isSurveyorVisibleUploadRow(row) {
  return Array.isArray(row?.details) && row.details.length > 0;
}

/**
 * @param {Array} rows
 * @param {"form" | "upload"} kind
 * @param {boolean} isSurveyRole
 */
export function filterRowsForSurveyor(rows, kind, isSurveyRole) {
  const list = rows || [];
  if (!isSurveyRole) return list;
  const keep =
    kind === "upload"
      ? isSurveyorVisibleUploadRow
      : isSurveyorVisibleSubmittedForm;
  return list.filter(keep);
}
